namespace Nobox.NoBoxCRM {
    export interface JsonImportResponse extends Serenity.ServiceResponse {
        data?: any[];
    }
}
